import { useState, useEffect } from 'react';
import { Scheduler, WeekView, MonthView, SchedulerDataChangeEvent, SchedulerViewSlot, SchedulerViewSlotProps, SchedulerViewItemProps, SchedulerViewItem } from '@progress/kendo-react-scheduler';
import {
  ListView,
  ListViewHeader,
  ListViewFooter,
  ListViewItemProps,
} from "@progress/kendo-react-listview";
import { groupBy } from "@progress/kendo-data-query";
import { FaTimesCircle } from 'react-icons/fa';


export interface GridDataItem {
  jobId: number;
  ref: number;
  client: string;
  worktype: string;
  employeeProjectmanager: string;
  employeeProjectmanagerId: number;
  site: string;
  description: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  scheduledEmployeeId: number;
  refFormatted: string;
}


const MyHeader = () => {
  return (
    <div>
      <ListViewHeader className="diaryListHeader diaryListText">
        Appointment List
      </ListViewHeader>      
    </div>
  );
};


const EventContainerList = ({ onData, selectedItem, setSelectedItem, onUpdateDragItem}: { onData: GridDataItem[], onUpdateDragItem?: (item: GridDataItem | null) => void, selectedItem: GridDataItem | null, setSelectedItem: (item: GridDataItem) => void }) => {
  const [collapsedGroups, setCollapsedGroups] = useState<Set<string>>(new Set());
  const [unscheduledFilter, setUnscheduledFilter] = useState<string>("");

  const [filteredData, setFilteredData] = useState(onData);

  const toggleGroup = (groupName: string) => {
    setCollapsedGroups(prev => {
      const newCollapsed = new Set(prev);
      if (newCollapsed.has(groupName)) {
        newCollapsed.delete(groupName);
      } else {
        newCollapsed.add(groupName);
      }
      return newCollapsed;
    });
  };

  const MyItemRender = (props: ListViewItemProps) => {
    let groupItemItem = props.dataItem;
    let items = groupItemItem.items;
    let groupName = groupItemItem.value;
    let isCollapsed = collapsedGroups.has(groupName);

    // const handleDragStart = (e: React.DragEvent, item: GridDataItem) => {
    //   e.dataTransfer.setData("application/reactflow", JSON.stringify(item)); // 'application/reactflow' is a custom MIME type.
    //   onUpdateDragItem(item);
    // };

    const trimDescription = (description: string, maxLength: number): string => {
    // If the description is longer than 'maxLength', trim it and add '...'
      return description.length > maxLength
        ? description.substring(0, maxLength) + '...'
        : description;
    };
    
    const GetItemClasses = (ref: any): string => {
      const refToSearch = unscheduledFilter.toString().toLowerCase().replace("j", "");

      const displayItem = (refToSearch.length > 0 && ref.toString().indexOf(refToSearch) > -1 || refToSearch.length == 0);
      return "groupitem__container"
    }

    return (
      <div style={{ marginTop: "1em" }}>
        <div className="groupname__container" onClick={() => toggleGroup(groupName)}>
          <p className='diaryListGroupContainer diaryListText'>
            {groupName} {isCollapsed ? '+' : '-'}
          </p>
        </div>
        {!isCollapsed && items.map((item: GridDataItem, idx: number) => (
          <>
          {/* {console.log("item", item)}
          hello1 */}
          {/* <div>{item.site}</div> */}
            <div key={idx} className={GetItemClasses(item.ref)} style={{border: selectedItem?.jobId === item.jobId ? "solid 2px #1e2a4e" : "solid 2px transparent"}} onClick={() => setSelectedItem(item) }>
              <p className='diaryListItem diaryListText'>
                <strong>{item.ref ? 'J' + item.ref : ''}</strong> - {trimDescription(item.description, 28)} 
                <br /> 
                <div style={{ color: "grey", fontSize: "9pt", margin: 0, fontWeight: "400" }}>{trimDescription(item.site, 28)}</div>
                <div style={{ color: "grey", fontSize: "9pt", margin: 0, fontWeight: "400" }}>{trimDescription(item.client, 28)}</div>
              </p>
            </div>
          </>
        ))}
      </div>
    );
  };

  const filterList = (event: any) => {
    setUnscheduledFilter(event.target.value);
  }
  const clearFilter = (event: any) => {
    setUnscheduledFilter("");
  }

  const filterArr = () => {
    const filteredItems = onData.filter((item) => {
      const lowerCaseFilter = unscheduledFilter.toLowerCase();
      return (
        item.client.toLowerCase().includes(lowerCaseFilter) ||
        item.site.toLowerCase().includes(lowerCaseFilter) ||
        item.refFormatted.toString().includes(lowerCaseFilter)
      );
    });

    setFilteredData(filteredItems);
  }

  useEffect(() => {
    filterArr();
  }, [unscheduledFilter, onData]);


  return (
    <div>
      <ListViewHeader className="diaryListHeader diaryListText" style={{ marginBottom: "0.5em" }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input 
            className='formik__input col-11' 
            type='text'
            placeholder='Search...'
            onChange={filterList}
            value={unscheduledFilter}
            style={{ height: 40, fontSize: "9pt" }}
          >            
          </input>          
          <FaTimesCircle
            onClick={clearFilter}
            className='cursor-pointer'
            style={{
              fontSize: "14pt",
              marginLeft: "0.7rem",
              color: "rgb(148 167 163)",
            }}
            title="Clear search"
          />
        </div>
      </ListViewHeader>
      <ListView
        
        data={groupBy(filteredData, [{ field: "employeeProjectmanager" }])}
        item={MyItemRender}
        style={{ width: "100%", borderRadius: "0.5em", minHeight: "400px", height: "400px" }}
        className='listview__container'
        header={MyHeader}
      />
    </div>    
  );
}

export default EventContainerList;